// extracted by mini-css-extract-plugin
export default {"container":"taskGeneratorComponent_container__w46pq","inputContainer":"taskGeneratorComponent_inputContainer__8GC4h"};